import { Badge } from "@/components/ui/badge";
import { Label } from "@/components/ui/label";
import { TableHead } from "@/components/ui/table";
import {
  Select, SelectTrigger, SelectValue, SelectContent, SelectItem,
} from "@/components/ui/select";
import { ArrowUpDown, ArrowUp, ArrowDown } from "lucide-react";

export const SORTABLE_COLS = [
  { key: "name",            label: "Name" },
  { key: "ticket_count",    label: "Tickets" },
  { key: "last_ticket_at",  label: "Last contact" },
  { key: "csat_avg",        label: "CSAT" },
  { key: "created_at",      label: "Created" },
];

export function FilterTag({ label, children }) {
  return (
    <div className="space-y-1">
      <Label className="text-[10px] uppercase tracking-wider text-slate-500 font-semibold">{label}</Label>
      {children}
    </div>
  );
}

export function TriToggle({ value, onChange, testid }) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="h-9 text-xs" data-testid={testid}><SelectValue /></SelectTrigger>
      <SelectContent>
        <SelectItem value="any" className="text-xs">Any</SelectItem>
        <SelectItem value="yes" className="text-xs">Yes</SelectItem>
        <SelectItem value="no" className="text-xs">No</SelectItem>
      </SelectContent>
    </Select>
  );
}

export function SortHead({ col, filters, onSort, className = "" }) {
  const meta = SORTABLE_COLS.find((s) => s.key === col);
  const active = filters.sort === col;
  const Icon = !active ? ArrowUpDown : (filters.dir === "asc" ? ArrowUp : ArrowDown);
  return (
    <TableHead className={className}>
      <button type="button" onClick={() => onSort(col)}
              data-testid={`sort-${col}`}
              className={`inline-flex items-center gap-1 text-xs uppercase tracking-wider ${
                active ? "text-indigo-600 font-bold" : "text-slate-500 hover:text-slate-700"
              }`}>
        {meta?.label || col}
        <Icon className="w-3 h-3" />
      </button>
    </TableHead>
  );
}

export function TagsCell({ tags }) {
  if (!tags?.length) return <span className="text-slate-300 text-xs">—</span>;
  const visible = tags.slice(0, 3);
  const overflow = tags.length - visible.length;
  return (
    <div className="flex flex-wrap items-center gap-1">
      {visible.map((t) => (
        <Badge key={t} variant="outline" className={`text-[10px] ${
          t === "vip" ? "bg-amber-50 text-amber-700 border-amber-200" : "bg-indigo-50 text-indigo-700 border-indigo-200"
        }`}>
          {t}
        </Badge>
      ))}
      {overflow > 0 && (
        <span className="text-[10px] text-slate-500">+{overflow}</span>
      )}
    </div>
  );
}
